export default __webpack_public_path__ + "static/media/shopifyNativeConcent8.6702f14c.svg";